import React from "react";
import { Flex, type FlexProps } from "@chakra-ui/react";

export function Checkbox({ children, ...props }: FlexProps) {
  return (
    <Flex
      id="activation-checkbox"
      align="center"
      border="1px"
      borderColor="product.gray.400"
      borderRadius="5px"
      boxSize={4}
      bg="white"
      flexShrink={0}
      justify="center"
      transition="border-color 100ms cubic-bezier(0.4, 0, 1, 1), background-color 100ms cubic-bezier(0.4, 0, 1, 1), box-shadow 200ms cubic-bezier(0.4, 0, 1, 1)"
      {...props}
    >
      {children}
    </Flex>
  );
}
